import Swal from 'sweetalert2';
import { isArray, forEach } from 'lodash';

const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

const ToastMixin = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 5000,
});

const ToastMixinHelpWeekDashboard = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 14000,
});

export const sendErroRequest = (error, mensagemDefault) => {
  if (error && error.response && error.response.data) {
    if (isArray(error.response.data.erro)) {
      forEach(error.response.data.erro, erro => createErrorNotification(erro.mensagem));
    } else if (isArray(error.response.data.erros)) {
      forEach(error.response.data.erros, erro => createErrorNotification(erro.mensagem));
    } else if (error.response.data.mensagem) {
      createErrorNotification(error.response.data.mensagem);
    } else {
      createErrorNotification(mensagemDefault);
    }
  } else {
    createErrorNotification(mensagemDefault);
  }
};

export const sendWarningModalXMLImport = (errors, success) => {
  const failedDocuments = formatFailedXMLText(6, errors);

  if (success > 0) {
    Swal.fire({
      type: NOTIFICATION_TYPES.WARNING,
      title: 'Download incompleto',
      html: `Total de documento(s) baixado(s): <b>${success}</b></br>
      Total de documento(s) não baixado(s): <b>${errors.length}</b></br></br>
      Documentos não baixados: </br>
      <strong>${failedDocuments}</strong>
      `,
    });
  } else {
    Swal.fire({
      type: NOTIFICATION_TYPES.ERROR,
      title: 'Download não concluído',
      html: `Total de documento(s) não baixado(s): <b>${errors.length}</b></br></br>
      Documentos não baixados: </br>
      <strong>${failedDocuments}</strong>
      `,
    });
  }
};

export const sendSuccessModalXMLImport = success => {
  Swal.fire({
    type: 'success',
    title: 'Download concluído!',
    html: `Total de documento(s) baixado(s): <b>${success}</b></br>`,
  });
};

const createNotification = (type, title, options = {}) => {
  ToastMixin.fire({
    type,
    title,
    ...options,
  });
};

export const createErrorNotification = (message, options = {}) =>
  createNotification(NOTIFICATION_TYPES.ERROR, message, options);

export const createSuccessNotification = (message, options = {}) =>
  createNotification(NOTIFICATION_TYPES.SUCCESS, message, options);

export const createInfoNotification = (message, options = {}) =>
  createNotification(NOTIFICATION_TYPES.INFO, message, options);

export const createInfoHelpNotification = message => {
  ToastMixinHelpWeekDashboard.fire({
    type: NOTIFICATION_TYPES.INFO,
    title: message,
  });
};

export const closeNotification = () => ToastMixin.clickConfirm();

const formatFailedXMLText = (quantity, errors) => {
  let failedDocuments = '';

  const messageSize = errors.length >= quantity ? quantity : errors.length;

  if (errors && errors.length > 0) {
    for (let i = 0; i < messageSize; i += 1) {
      failedDocuments += `${errors[i].numeroDocumentoFiscal}`;
      if (errors.length > quantity && i === quantity - 1) {
        failedDocuments += '...';
      } else if (errors.length <= quantity && i === messageSize - 1) {
        failedDocuments += '.';
      } else {
        failedDocuments += ', ';
      }
    }
  }
  return failedDocuments;
};
